import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Button, SxProps, Theme } from '@mui/material';
import { flexBase } from '../../../Constants';
import useBreakpoints from '../../../hooks/useBreakpoint';
import { ReactComponent as CdeLogo } from './cde_logo.svg';
import { ReactComponent as CdeInfrastructureLabel } from './cde_infrastructure_label.svg';
import { ReactComponent as CdeInfrastructureLabelDark } from './cde_infrastructure_label_dark.svg';
import { vars } from '../../../Theme';
import { resetProjectMetadata } from '../../../redux/project/sliceProjectMetadata';

/**
 * Cosmetic component that shows logo and brand.
 */
export default ({ boxSx: overrideBoxSx, darkMode }: { boxSx?: SxProps<Theme>; darkMode?: boolean }) => {
    /** Detect screen size. */
    const { isMobile, isTablet } = useBreakpoints();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    /** Styles for the logo's wrapper element. */
    const boxSx: SxProps = {
        ...flexBase,
        flexDirection: 'row',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        width: isMobile ? 100 : isTablet ? 180 : 'auto',
        ...overrideBoxSx,
    };

    const labelStyle: React.CSSProperties = {
        paddingLeft: '8px',
    };
    
    const onLogoClick = () => {
        dispatch(resetProjectMetadata());
        navigate('/');
    };

    return (
        <Box sx={boxSx}>
            <Button onClick={onLogoClick}>
                <CdeLogo fill={vars.logoBlue} />
                {darkMode ? <CdeInfrastructureLabelDark style={labelStyle} /> : <CdeInfrastructureLabel style={labelStyle} />}
            </Button>
        </Box>
    );
};
